import * as CONST from "../const/action.const";

const initialState = {
  requestData: null,
  pending_requests: [],
  inProgrress_requests: [],
  reply_request: null,
  students_from_request: null,
};
export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CONST.REQUEST_ACCOUNT_SUCCESS:
      return {
        ...state,
        requestData: payload,
      };
    case CONST.REQUEST_ACCOUNT_FAILURE:
      return {
        ...state,
        requestData: null,
      };
    case CONST.GET_PENDING_REQUESTS_SUCCESS:
      return {
        ...state,
        pending_requests: payload.reverse(),
      };
    case CONST.GET_PENDING_REQUESTS_FAILURE:
      return {
        ...state,
        pending_requests: [],
      };
    case CONST.GET_INPROGRESS_REQUESTS_SUCCESS:
      return {
        ...state,
        inProgrress_requests: payload.reverse(),
      };
    case CONST.GET_INPROGRESS_REQUESTS_FAILURE:
      return {
        ...state,
        inProgrress_requests: [],
      };
    case CONST.GET_REQUEST_DETAILS_SUCCESS:
      return {
        ...state,
        requestData: payload,
      };
    case CONST.GET_REQUEST_DETAILS_FAILURE:
      return {
        ...state,
        requestData: null,
      };
    case CONST.REPLY_FOR_REQUEST_SUCCESS:
      return {
        ...state,
        reply_request: payload,
      };
    case CONST.REPLY_FOR_REQUEST_FAILURE:
      return {
        ...state,
        reply_request: null,
      };
    case CONST.CREATE_STUDENT_FROM_REQID_SUCCESS:
      return {
        ...state,
        students_from_request: payload,
      };
    case CONST.CREATE_STUDENT_FROM_REQID_FAILURE:
      return {
        ...state,
        students_from_request: null,
      };
    default:
      return state;
  }
}
